export const config = {
  eventGroup: 'tgame_fab_v3_4_mo_20251212' /* 确定一下这个应该是英文 */,
  identify: 'tgame',
  eventTags: ['tgame', 'fab', 'v3_4', 'mo']
};

/**
 * 当不主动设置时采取默认上报
 */
// noinspection JSUnresolvedVariable
if (IS_MASTER_ENV && typeof DEPLOY_MASTER_HTTP_URL === 'string' && config.identify === 'other') {
  // noinspection JSUnresolvedVariable
  const url = DEPLOY_MASTER_HTTP_URL;
  const identify = url.split('.')[0];
  const validIdentifierList = [
    'jx3',
    'jx3yq',
    'daily',
    'js3',
    'js2',
    'zjjh',
    'jxsj2',
    'jx',
    'jx2',
    'zzq',
    'gcg2',
    'cpol',
    'jx3wbl',
    'xoyo',
    'sx',
    'projectcat',
    'jxgl',
    'ssg',
    'cityscape'
  ];
  config.identify = validIdentifierList.indexOf(identify) > -1 ? identify : 'xishanju_com';
  const matches = url.match(/\/(\w+)\//);
  config.eventTags = matches ? [matches[1]] : [];
  // noinspection SpellCheckingInspection
  config.eventGroup = url
    .replace('.xoyo.com', '')
    .replace(/\/$/, '')
    .replace(/[./-]/g, '_');
}

console.log('埋点上报参数: ' + JSON.stringify(config));

export default function createTracker(report, getDiffRouteTime) {
  return {
    click_share: function(title) {
      report({
        eventName: 'click_share',
        eventDescription: '点击分享',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    click_bgm: function(title) {
      report({
        eventName: 'click_bgm',
        eventDescription: '点击声音开关',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    click_go_gw: function() {
      report({
        eventName: 'click_go_gw',
        eventDescription: '进入官网'
      });
    },
    click_go_cdk: function() {
      report({
        eventName: 'click_go_cdk',
        eventDescription: '获取CDK'
      });
    },
    click_watch_video: function() {
      report({
        eventName: 'click_watch_video',
        eventDescription: '播放PV视频'
      });
    },
    click_download: function(title) {
      report({
        eventName: 'click_download',
        eventDescription: '点击下载',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
